// extracted by mini-css-extract-plugin
module.exports = {"header":"HtcConfirm_header__2WWEe","icon":"HtcConfirm_icon__1qPWG","title":"HtcConfirm_title__2r7b4","message":"HtcConfirm_message__35QuG","footer":"HtcConfirm_footer__1Vkms"};